import { Link, useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import { Form, Input, Button, Typography, Card } from 'antd';
import axios from 'axios';

import '../styles/Login.css';
import brainwiththought from '../assets/brainwiththought.gif';
import { userLogin } from '../config/api';
import { Encrypt } from '../utils/encryption';
import { useAuth } from '../context/AuthContext'; // ✅ Import context

const { Title } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const { setToken } = useAuth(); // ✅ Use context for In-memory token
  const [ hovered, setHovered ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ responseMessage, setResponseMessage ] = useState(null);

  const onFinish = async (values) => {
    console.log('🔐 Login Attempt:', values);
    setLoading(true);
    setResponseMessage('validating...');

    try {

      const responsefromLambda = await axios.post( userLogin, Encrypt(values), {
        headers: {
          'Content-Type': 'application/json',
        }
        //withCredentials: true // ✅ REQUIRED for cookies to be sent/received
      });
      const data = responsefromLambda.data;

      console.log(`Database Response for Login-`, responsefromLambda);

      // ✅ Capture token from backend response
      if (data.token) {
        setToken(data.token); // ✅ Store token in context
        navigate('/userhome', {replace: true}); // ✅ Redirect user to UserHome
      }

      setResponseMessage(data);
      console.log('✅ Login Response:', responsefromLambda)

    } catch (error){
      console.error('Login error:', error);
      // setResponseMessage(error.response?.data?.message || error.message || 'Login Failed. Please try again')
      
      // console.error('Registration error:', error);
      setResponseMessage(`🤔${error.response?.data?.message || '🤔Something is not right'}`);

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="Login-logo-container">
        <img src={brainwiththought} alt="MindBank Logo" className="Login-brain-logo" />
        
      </div>
      <Title level={2}>Login to MindBank</Title>
      <Form
        name="login"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
        className="login-form"
      >
        <Form.Item
          label="User Name (Email id)"
          name="userName"
          rules={[{ required: true, message: 'Please enter your User Name' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: 'Please enter your Password' }]}
        >
          <Input.Password />
        </Form.Item>
          <div style={{ textAlign: 'right', marginBottom: '1rem' }}>
            <Link
              to="/resetpassword"
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              style={{ fontSize: '0.9rem', transition: 'color 0.2s ease' }}
            >
              { hovered ? 'Reset Password' : 'Forgot Password?'}
            </Link>
          </div>

        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            {loading ? 'Validating...' : 'LOGIN'}
          </Button>
        </Form.Item>
      </Form>

      {responseMessage && (
        <Card title = 'Login Message' style={{marginTop : 24}}>
          <pre>{JSON.stringify(responseMessage, null, 2)}</pre>
        </Card>
      )}

    </div>
  );
};

export default Login;
